// extracted by css-extract-rspack-plugin
export default {"ResourceListItem":"tnjgd"};